import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { PreOrderListModel } from '../models/models'

export class GetPreOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/preOrder/getPreOrder',
      requesterInfo,
    })
  }

  public async getPreOrder(request: string): Promise<PreOrderListModel[]> {
    return await this.postAsync<PreOrderListModel[]>(JSON.stringify(request))
  }
}
